// extracted by mini-css-extract-plugin
export default {"loaderWrap":"ProtectedRoute_loaderWrap__RxF2Y","spinner":"ProtectedRoute_spinner__mnTkm","spin":"ProtectedRoute_spin__0wgf+"};